export const paths = {
  root: '/',
  news: '/news',
  osteoporosisLecture: '/osteoporosis-public-lecture',
  firstVisiting: '/first-visiting',
  info: '/info',
  appointment: '/appointment',
  access: '/access',
  cerec: '/cerec',
  kids: '/kids',
  childcareService: '/childcare-service',
  orthodontic: '/Orthodontic',
  covidMeasures: '/covid-19-measures',
  whitening: '/whitening',
  facilityStandards: '/facility-standards',
  dentures: '/dentures',
  implantation: '/implantation',
  price: '/price',
  paymentMachine: '/payment-machine',
  ems: '/ems',
  periodontal: '/periodontal',
  notFound: '/404',

  about: {
    root: '/about',
    closedDays: {
      root: '/about/closed-days',
      obon2025: '/about/closed-days/2025-obon',
    },
    priceRevision20261101: '/about/price-revision-2026-11-01',
  },

  recruitment: {
    root: '/recruitment',
    jobs: {
      root: '/recruitment/jobs',
      dentistFullTime: '/recruitment/jobs/dentist-full-time',
      dentistPartTime: '/recruitment/jobs/dentist-part-time',
      hygienistMaintenance: '/recruitment/jobs/hygienist-maintenance',
      hygienistAssistant: '/recruitment/jobs/hygienist-assistant',
      dentalAssistantReceptionist: '/recruitment/jobs/dental-assistant-receptionist',
      dentalAssistant: '/recruitment/jobs/dental-assistant',
      receptionist: '/recruitment/jobs/receptionist',
    },
    staffTrainingProgram: {
      root: '/recruitment/staff-training-program',
      hygienistTrainingProgram: {
        root: '/recruitment/staff-training-program/dental-hygienist-training-program',
        introductionOfDrMaruhashi:
          '/recruitment/staff-training-program/dental-hygienist-training-program/introduction-of-dr-maruhashi',
      },
    },
    event: {
      root: '/recruitment/event',
      recruitmentEvent20250420: '/recruitment/event/recruitment-event-2025-04-20',
    },
  },
} as const;

export const flattenPaths = (obj: unknown): string[] => {
  if (typeof obj === 'string') return [obj];
  if (typeof obj === 'object' && obj !== null) {
    return Object.values(obj).flatMap(flattenPaths);
  }
  return [];
};
